import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./EducationTermsUIHelpers";

const EducationTermsUIContext = createContext();

export function useEducationTermsUIContext() {
  return useContext(EducationTermsUIContext);
}

export const EducationTermsUIConsumer = EducationTermsUIContext.Consumer;

export function EducationTermsUIProvider({ educationTermsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewEducationTermPage: educationTermsUIEvents.openNewEducationTermPage,
    openEditEducationTermPage: educationTermsUIEvents.openEditEducationTermPage
  };

  return (
    <EducationTermsUIContext.Provider value={value}>
      {children}
    </EducationTermsUIContext.Provider>
  );
}